import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ProgramaListarComponent } from './programas/components/programa-listar/programa-listar.component'
import { CursoListarComponent } from './lato-sensu/components/curso-listar/curso-listar.component'

const routes: Routes = [
  { path: 'programas', component: ProgramaListarComponent },
  { path: 'lato-sensu', component: CursoListarComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
